import React, { useEffect, useState } from "react";
import "../styles/About.css";

const About = () => {
  const [storeLink, setStoreLink] = useState("#features");

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent)) {
      //setStoreLink("https://play.google.com/store/apps/details?id=com.rondago.app"); // Substitua pelo link correto do app na Play Store
      setStoreLink("https://play.google.com/"); // Substitua pelo link correto do app na Play Store
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      //setStoreLink("https://apps.apple.com/br/app/rondago/id123456789"); // Substitua pelo link correto do app na Apple Store
      setStoreLink("https://apps.apple.com/br/"); // Substitua pelo link correto do app na Apple Store
    }
  }, []);

  return (
    <section className="about-section">
      <div className="about-text">
        <h2>O que é o RondaGO?</h2>
        <p>
          O <strong>RondaGO</strong> é a solução completa para a <strong>gestão operacional de condomínios</strong>.  
          Com tecnologia baseada em <strong>QR Code</strong>, permite que síndicos e administradores <strong>controlem rondas, inspeções, 
          manutenção de equipamentos e monitoramento de pendências</strong>, tudo em um único lugar.  
        </p>
        <p>
          Reduza o tempo gasto com papelada e planilhas manuais. O <strong>RondaGO digitaliza e automatiza processos</strong>,
          garantindo <strong>mais segurança, organização e eficiência</strong> para o seu condomínio.  
        </p>
        <a href={storeLink} className="btn-primary" target="_blank" rel="noopener noreferrer">
          Teste Gratuitamente
        </a>
      </div>
      <div className="about-image">
        <img src="/assets/sindico-feliz.png" alt="Síndico Feliz com RondaGO" />
      </div>
    </section>
  );
};

export default About;
